/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsUserAlphabet,
    SharedserviceMelcoModelsUserAlphabetFromJSON,
    SharedserviceMelcoModelsUserAlphabetFromJSONTyped,
    SharedserviceMelcoModelsUserAlphabetToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet
 */
export interface SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsUserAlphabet>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    list: Array<SharedserviceMelcoModelsUserAlphabet>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet {
    return SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoModelsUserAlphabetFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabetToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoModelsUserAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoModelsUserAlphabetToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


